import { useEffect, useRef } from "react";
import { useTrackEvent } from "./useTrackEvent";

interface PageViewTrackingOptions {
  shouldTrack?: boolean;
  dependencies?: ReadonlyArray<unknown>;
}

export const usePageViewTracking = (
  eventName: string,
  eventProperties = {},
  options: PageViewTrackingOptions = {}
): void => {
  const { trackEvent } = useTrackEvent();
  const hasTrackedRef = useRef(false);
  const { shouldTrack = true, dependencies = [] } = options;

  useEffect(() => {
    if (hasTrackedRef.current || !shouldTrack) {
      return;
    }

    trackEvent(eventName, eventProperties);
    hasTrackedRef.current = true;
  }, [eventName, eventProperties, shouldTrack, trackEvent, ...dependencies]);
};
